import AAFPlayer from '../AAFPlayer/AAFPlayer';
import {AAFPLAYER_PLAY} from '../AAFPlayer/constants';
import Utils from './Utils';
import DeviceStorage from '../components/DeviceStorage/DeviceStorage';
import ChannelSingleton from '../components/Epg/ChannelsSingleton';
import store from '../store';
import channelBlockedUtil from "src/utils/ChannelBlockedUtil";

class TvChannelUtil {

    static handlePREV() {
        let playerState = AAFPlayer.getCurrentPlayingState(false);
        let response = {
            action: null,
            params: null
        };  
        let isInfull = false;
        // Verifica full
        if(playerState === AAFPLAYER_PLAY) {
            // Si esta en play y está en full
            let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
            console.log('[TvChannelUtil] current AAFPlayerOptions ', playerOptions);
            if(playerOptions && playerOptions.size  && playerOptions.size.width && playerOptions.size.width == 1280) {
                if(playerOptions.islive) {
                    isInfull = true;
                }
            }
            else {
                if(playerOptions && Utils.isNullOrUndefined(playerOptions.size)) {
                    if(playerOptions.islive) {
                        isInfull = true;
                    }   
                }
            }

            // Si esta playeando en full y hay previousChannel entonces se intenta el cambio de canal
            let previous = DeviceStorage.getItem("previousChannel");
            
            let canPlayPrevious = ChannelSingleton.canPlayChannel(previous);
          if (isInfull && canPlayPrevious && previous !== TvChannelUtil.getLastChannel()) {
                response = {
                    action: 'channelchange',
                    gid: previous
                }; 
            }
        }

        // Si no esta playing se verifica si esta en nodo "node"
        if(!isInfull) {
            if(window.location.href.indexOf('/node/') !== -1 
                || window.location.href.indexOf('/vcard/') !== -1
                || window.location.href.indexOf('/epg/') !== -1) {
                response = {
                    action: 'redirecttv',
                    gid: null
                }; 
            }
        }

        console.log('[TvChannelUtil] current AAFPlayerOptions ', response);
        return response;
    }


  static getProfileKey() {
    const profile = store.getState().profile;
    return `lastChannel${profile.gamification_id ? ('_' + profile.gamification_id) : ''}`;
  }

  static setLastChannel(gid) {

    const lasChannelProfileKey = this.getProfileKey();
    const lastChannel = TvChannelUtil.getLastChannel();    
    DeviceStorage.setItem(lasChannelProfileKey, gid);
    if (!Utils.isNullOrUndefined(lastChannel)) {
      (parseInt(gid) !== parseInt(lastChannel)) && DeviceStorage.setItem('previousChannel', lastChannel);
    }
  }

  static getLastChannel() {

    const lasChannelProfileKey = this.getProfileKey();
    const lastChannel = DeviceStorage.getItem(lasChannelProfileKey);    
    return lastChannel;

  }

  static getNextChannelIndex(channels, index){
    if (channels.length-1 === index) return 0
    return index + 1;
  }

  static getBlockedChannels(){
    return channelBlockedUtil.get('blockedChannels') || [];
  }

  static async getNextChannelAvailable(channels, index, channelsBlocked) {
    let next_group_id;
    let nextIndex = this.getNextChannelIndex(channels, index);

    if(Array.isArray(channels) && channels.length > 0) {
        for(var i = 0; i<channels.length; i++){
            const nextChannel = channels[nextIndex];
            const {group_id} = nextChannel || {};
            next_group_id = group_id

            if(ChannelSingleton.canPlayChannel(next_group_id) && !channelsBlocked.includes(next_group_id)){
                break;
            } 
            
            nextIndex = this.getNextChannelIndex(channels, nextIndex)
        }
    }
    return next_group_id;
  }

  static async getNextChannelPlayable(group_id) {
    const channels = await new ChannelSingleton().getChannels();
    const blockedChannels = this.getBlockedChannels();

    const channelIndex = channels.findIndex((channel) => channel.group_id === group_id);

    return new Promise(
      ((resolve, reject) => {
        if (channelIndex === -1) {
          reject('[TvChannelUtil] NO se ha encontrado el canal ' + group_id + ' en linealChannels')
        }
        resolve(this.getNextChannelAvailable(channels, channelIndex, blockedChannels));
      })
    );
  }
}



export default TvChannelUtil;



// WEBPACK FOOTER //
// ./src/utils/TvChannelUtil.js